import { observer } from "mobx-react";
import React from "react";
import { StyleSheet } from "react-native";
import { Spacer } from "~/components/Spacer";
import { BodyText } from "~/components/V2/Text/BodyText";
import { View } from "~/components/V2/View";
import { styleConstantsV2 } from "~/style/styleConstantsV2";
import { Icon } from "../Icon";
import { Pressable } from "./Pressable";
import type { PressableState } from "./Pressable";

const S = StyleSheet.create({
  iconContainer: {
    minWidth: 24,
  },
});

export const Field = observer(function Field({
  label,
  value,
  isLast,
  isEditable = false,
  onPress,
}: {
  label: string;
  value?: string | null;
  isLast?: boolean;
  isEditable?: boolean;
  onPress?: () => void;
}) {
  return (
    <Pressable
      onPress={onPress}
      flexDirectionRow
      padding24
      style={(state: Omit<PressableState, "focused">) => {
        return {
          backgroundColor: state.hovered
            ? styleConstantsV2.colorPrimaryBg
            : "transparent",
          borderColor: styleConstantsV2.colorGrey20,
          borderTopWidth: 1,
          borderBottomWidth: isLast ? 1 : 0,
        };
      }}
    >
      <BodyText sizeLarge weightRegular colorGrey numberOfLines={1}>
        {intl.formatMessage(
          {
            id: "y2+tOy",
            defaultMessage: "{label}: <b>{value}</b>",
            description: "Field for pet name",
          },
          {
            b: (chunk: React.ReactNode[]) => (
              <BodyText
                key={chunk[0] as string}
                colorBlack
                sizeLarge
                weightBold
              >
                {chunk[0]}
              </BodyText>
            ),
            label,
            value: value ?? "-",
          },
        )}
      </BodyText>

      <Spacer small />

      {isEditable && (
        <View flex alignItemsFlexEnd style={S.iconContainer}>
          <Icon name="edit" size={24} color={styleConstantsV2.colorBlack} />
        </View>
      )}
    </Pressable>
  );
});
